import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNav = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <header className="border-b border-gray-200 bg-white/95 dark:border-gray-800 dark:bg-black/95 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
        <img
          src="/logo.png"
          alt="Therefore - Brand Archetype Self-Discovery Quiz"
          className="h-7 sm:h-9 cursor-pointer dark:invert-0 invert"
          onClick={() => handleNav('/')}
        />

        {/* Desktop nav */}
        <div className="hidden sm:flex items-center gap-3">
          <Button
            variant="ghost"
            className="text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white text-sm px-3 h-9"
            onClick={() => handleNav('/report-history')}
            data-testid="report-history-nav-btn"
          >
            My Reports
          </Button>
          <Button
            variant="outline"
            className="border-gray-300 text-gray-900 hover:bg-gray-100 dark:border-gray-600 dark:text-white dark:hover:bg-gray-800 text-sm px-3 h-9"
            onClick={() => handleNav('/admin')}
            data-testid="admin-nav-btn"
          >
            Admin
          </Button>
        </div>

        {/* Mobile: hamburger */}
        <div className="flex items-center gap-2 sm:hidden">
          <button
            className="text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white p-1"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {menuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="sm:hidden border-t border-gray-200 bg-white/95 dark:border-gray-800 dark:bg-black/95 backdrop-blur-sm px-4 py-3 space-y-2">
          <button
            className="w-full text-left text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white py-2.5 px-3 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800/60 text-sm font-medium transition-colors"
            onClick={() => handleNav('/report-history')}
            data-testid="mobile-report-history-btn"
          >
            My Reports
          </button>
          <button
            className="w-full text-left text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white py-2.5 px-3 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800/60 text-sm font-medium transition-colors"
            onClick={() => handleNav('/admin')}
            data-testid="mobile-admin-btn"
          >
            Admin
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
